function initialize() {
  const brands = "healo  hmc  epassi  wellnet  actiway  dif  football  tennis".split(
    "  "
  );

  function setBrand(index) {
    localStorage.setItem("brand", brands[index]);
    window.location.reload();

    return brands[index];
  }

  function setBrandByName(name) {
    localStorage.setItem("brand", name);
    window.location.reload();

    return [name, brands.indexOf(name)];
  }

  function showAllBrands(index = 0) {
    setBrand(index);
    localStorage.setItem("lastIndex", index.toString());
  }

  const lastIndex = parseInt(localStorage.getItem("lastIndex"), 10);

  if (!isNaN(lastIndex) && lastIndex < brands.length - 1) {
    const nextIndex = lastIndex + 1;
    console.log("Will show", nextIndex, brands[nextIndex]);
    setTimeout(() => {
      showAllBrands(nextIndex);
    }, 4000);
  }
  window.setBrand = setBrand;
  window.showAllBrands = showAllBrands;
  window.setBrandByName = setBrandByName;
}

export default {
  initialize
};



// WEBPACK FOOTER //
// ./src/modules/utils/dev-utils.js